import React from "react";
import { useTranslation } from "react-i18next";
import { MapPin, Clock, Phone, Mail, ExternalLink } from "lucide-react";
import { CONTACT, whatsappLink } from "../lib/constants";

export default function FindUs() {
  const { t } = useTranslation();
  return (
    <section data-testid="findus-page" className="bg-brand-black py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="mb-10 max-w-3xl">
          <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-brand-orange">
            {t("nav.findus")}
          </span>
          <h1 className="mt-2 font-display text-5xl uppercase leading-[0.95] sm:text-6xl lg:text-7xl">
            {t("findus.title")}
          </h1>
          <div className="mt-4">
            <OpenStatusBadge />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
          <div className="md:col-span-8">
            <div className="aspect-[16/10] w-full overflow-hidden border-2 border-brand-orange hard-shadow">
              <iframe
                title="Cascante Moto Rental — San Juan del Sur"
                src="https://www.google.com/maps?q=San+Juan+del+Sur,+Rivas,+Nicaragua&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          <aside className="md:col-span-4">
            <div className="border-2 border-brand-orange bg-brand-black p-6 text-white">
              <h3 className="font-display text-3xl uppercase">Cascante</h3>
              <p className="text-xs font-bold uppercase tracking-widest text-brand-orange">
                Moto Rental
              </p>

              <ul className="mt-6 space-y-4 text-sm">
                <li className="flex items-start gap-3">
                  <MapPin className="h-5 w-5 shrink-0 text-brand-orange" />
                  <span>{t("findus.address")}</span>
                </li>
                <li className="flex items-start gap-3">
                  <Clock className="h-5 w-5 shrink-0 text-brand-orange" />
                  <span>{t("findus.hours")}</span>
                </li>
                <li className="flex items-start gap-3">
                  <Phone className="h-5 w-5 shrink-0 text-brand-orange" />
                  <a href={whatsappLink()} className="hover:text-brand-orange">
                    {CONTACT.whatsappDisplay}
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <Mail className="h-5 w-5 shrink-0 text-brand-orange" />
                  <a href={`mailto:${CONTACT.email}`} className="break-all hover:text-brand-orange">
                    {CONTACT.email}
                  </a>
                </li>
              </ul>

              <a
                data-testid="get-directions-link"
                href={CONTACT.googleMaps}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex w-full items-center justify-center gap-2 border-2 border-brand-orange bg-brand-orange px-4 py-3 font-display text-lg uppercase tracking-wider text-white hover:bg-transparent"
              >
                {t("findus.directions")} <ExternalLink className="h-4 w-4" />
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
